import { createFileRoute, useNavigate } from "@tanstack/react-router"
import Organization from "@/components/account/professional/organization"
import { useUserType } from "@/hooks/use-user-type"

export const Route = createFileRoute("/_authed/account/organization")({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate()

  const { isProfessional } = useUserType()
  if (!isProfessional) navigate({ to: ".." })

  return <Organization />
}
